export const FINANCE_QUEUE_LIFECYCLE_TABS = [
  { id: 'ativos', label: 'Ativos' },
  { id: 'pausados', label: 'Pausados' },
  { id: 'cancelados', label: 'Cancelados' },
  { id: 'historico', label: 'Histórico' },
] as const

export type FinanceQueueLifecycle = (typeof FINANCE_QUEUE_LIFECYCLE_TABS)[number]['id']

export const FINANCE_QUEUE_HISTORY_STATUSES = ['CONTRATO_ASSINADO', 'CONCLUIDO'] as const

export function isFinanceQueueHistoryStatus(status: string): boolean {
  return (FINANCE_QUEUE_HISTORY_STATUSES as readonly string[]).includes(status)
}
